import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/outline';

import { MenuItem } from './navigation-items';
import NavigationItem from './NavigationItem';
import classNames from '../helpers/classNames';

const VISIBLE_COUNT = 5;

export default function TramitesNav({
  items,
  textColorClass = 'text-gray-600',
}: Readonly<{ items: MenuItem[]; textColorClass?: string }>) {
  const [expanded, setExpanded] = useState<boolean>(false);

  // When collapsed, always keep the first items plus the active one visible so
  // the current page is never hidden behind "Ver más".
  const collapsedItems = items.filter(
    (item, index) => index < VISIBLE_COUNT || item.current,
  );
  const visibleItems = expanded ? items : collapsedItems;
  const hiddenCount = items.length - visibleItems.length;

  const ChevronIcon = expanded ? ChevronUpIcon : ChevronDownIcon;

  return (
    <>
      {visibleItems.map((item: MenuItem) => (
        <NavigationItem
          item={item}
          textColorClass={textColorClass}
          key={item.name}
        />
      ))}
      {items.length > VISIBLE_COUNT && (
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          className={classNames(
            textColorClass,
            'group flex w-full items-center px-2 py-2 text-sm font-medium rounded-md hover:bg-gray-200 hover:text-blue-700',
          )}
        >
          <ChevronIcon
            className={classNames(
              textColorClass,
              'mr-3 shrink-0 h-6 w-6 group-hover:text-blue-700',
            )}
            aria-hidden="true"
          />
          {expanded ? 'Ver menos' : `Ver más (${hiddenCount})`}
        </button>
      )}
    </>
  );
}
